export const RenderShippingAddress = (data) => {
  if (!data) return '';
  const parts = [
    data.address_province ? `จ.${data.address_province}` : '',
    data.address_district ? `อ.${data.address_district}` : '',
    data.address_sub_district ? `ต.${data.address_sub_district}` : '',
    data.address_zipcode || '',
    data.address || '',
  ].filter((e) => e !== '' && e !== undefined && e !== null);
  return parts.join(' ');
};

export const SHIPPING_OPTIONS = [
  {
    label: 'Kerry',
    value: 'Kerry',
    phoneNumber: '0736475645',
    link: 'https://www.google.co.th',
  },
  {
    label: 'Flash',
    value: 'Flash',
    phoneNumber: '0736475645',
    link: 'https://www.google.co.th',
  },
  {
    label: 'SCG',
    value: 'SCG',
    phoneNumber: '0736475645',
    link: 'https://www.google.co.th',
  },
];
